"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useContextualSaveBar = void 0;
var useContextualSaveBar_1 = require("./useContextualSaveBar");
Object.defineProperty(exports, "useContextualSaveBar", { enumerable: true, get: function () { return useContextualSaveBar_1.useContextualSaveBar; } });
